import { IsolatedCoroutineScopensqylcikdcw7 as IsolatedCoroutineScope } from '../../../kotlin-js/js/coroutines/internal/IsolatedCoroutineScope.mjs';
import { CoroutineStart_UNDISPATCHED_getInstance36t7e2kqqnuqp as CoroutineStart_UNDISPATCHED_getInstance } from '../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function runIsolatedJob(block) {
  var job = launch(IsolatedCoroutineScope(), VOID, CoroutineStart_UNDISPATCHED_getInstance(), block);
  return Job$cancel$ref(job);
}
function Job$cancel$ref(p0) {
  return constructCallableReference(() => {
    p0.hy();
    return Unit_instance;
  }, 0, 0, 6, VOID, [p0]);
}
//region block: exports
export {
  runIsolatedJob as runIsolatedJob3cgv8kybs77yh,
};
//endregion

//# sourceMappingURL=runIsolatedJob.mjs.map
